function Footer() {
  return (
    <footer className="site-footer">
      <div className="footer-container">

        {/* LOGO + DESCRIPTION */}
        <div className="footer-col footer-brand">
          <h2><a href='https://oxfordexports.in/' className="defaultColor">Oxford Exports</a></h2>
          <p>
          We specialize in facilitating high-value Petroleum and Petrochemical transactions by representing a network of qualified and reputable buyers and Sellers across the Middle East, Europe, East Africa, and East Asia.
          </p>
        </div>

       

        {/* QUICK LINKS */}
        <div className="footer-col">
          <h4>Quick Links</h4>
          <ul>
            <li><a href="/">Home</a></li>
            <li><a href="/aboutus">About</a></li>
            <li><a href="/product">Product</a></li>
            <li><a href="/contact">Contact</a></li>
          </ul>
        </div>

         {/* CONTACT INFO */}
         <div className="footer-col">
          <h4>Contact Us</h4>
          <p>
          📍 <span>Suite 4 A The Monarch <br />
          PT Usha Road, India 682011</span>
          </p>
          <p>📞 +91 9895211011</p>
          <p>✉️ subu@oxfordexports.in</p>
        </div>

      </div>

      <div className="footer-bottom">
        <p>© 2026 OxfordExports Trading Company LLC. All Rights Reserved.</p>
      </div>
    </footer>
  );
}

export default Footer;
